import Autosuggest from "react-autosuggest";
import horsey from "fuzzysearch";
import React from "react";
import { quitaAcentos } from "../utils/helpers";
import SVGInline from "react-svg-inline";

// Imagine you have a list of grupos that you'd like to autosuggest.
const theme = {
	container: {
		position: "relative"
	},
	input: {
		width: "100%",
		height: 52,
		padding: "10px 20px",
		fontFamily: "Roboto, sans-serif",
		fontWeight: 300,
		fontSize: 16,
		border: "1px solid #aaa",
		borderTopLeftRadius: 4,
		borderTopRightRadius: 4,
		borderBottomLeftRadius: 4,
		borderBottomRightRadius: 4,
		boxSizing: "border-box"
	},
	inputFocused: {
		outline: "none",
		boxSizing: "border-box"
	},
	inputOpen: {
		borderBottomLeftRadius: 0,
		borderBottomRightRadius: 0,
		boxSizing: "border-box"
	},
	suggestionsContainer: {
		display: "none",
		boxSizing: "border-box"
	},
	suggestionsContainerOpen: {
		display: "block",
		position: "absolute",
		top: 51,
		width: "100%",
		border: "1px solid #aaa",
		backgroundColor: "#fff",
		fontFamily: "Roboto, sans-serif",
		fontWeight: 300,
		fontSize: 16,
		borderBottomLeftRadius: 4,
		borderBottomRightRadius: 4,
		zIndex: 2,
		boxSizing: "border-box"
	},
	suggestionsList: {
		margin: 0,
		padding: 0,
		listStyleType: "none",
		boxSizing: "border-box"
	},
	suggestion: {
		cursor: "pointer",
		padding: "10px 20px",
		boxSizing: "border-box",
		marginBottom: 0
	},
	suggestionHighlighted: {
		backgroundColor: "#ddd",
		boxSizing: "border-box"
	}
};

class Search extends React.Component {
	constructor(props) {
		super(props);
		// Autosuggest is a controlled component.
		// This means that you need to provide an input value
		// and an onChange handler that updates this value (see below).
		// Suggestions also need to be provided to the Autosuggest,
		// and they are initially empty because the Autosuggest is closed.
		this.state = {
			fase: this.props.fase,
			value: "",
			suggestions: [],
			ide: "",
			grupos: []
		};
		// BINDINGS
		this.getSuggestions = this.getSuggestions.bind(this);
		this.onChange = this.onChange.bind(this);
		this.onSuggestionsFetchRequested = this.onSuggestionsFetchRequested.bind(
			this
		);
		this.onSuggestionsClearRequested = this.onSuggestionsClearRequested.bind(
			this
		);
		this.onSuggestionSelected = this.onSuggestionSelected.bind(this);
	}

	componentDidMount(props) {
		if (
			this.props.agrupaciones !== undefined &&
			this.props.agrupaciones !== null
		) {
			const array = Object.keys(this.props.agrupaciones)
				.filter(key => {
					return (
						this.props.agrupaciones[key].cat ===
							this.props.agrupaciones[this.props.ide].cat &&
						this.props.agrupaciones[key][`${this.props.fase}tot`] > 0 &&
						key !== this.props.ide
					);
				})
				.map(key => ({
					name: this.props.agrupaciones[key].nom,
					ide: this.props.agrupaciones[key].ide
				}));
			// console.log(JSON.stringify(array));
			// console.log(array);
			this.setState({
				grupos: array
			});
		}
	}

	getSuggestions(value) {
		const inputValue = value.trim().toLowerCase();
		const inputLength = inputValue.length;

		return inputLength === 0
			? []
			: this.state.grupos.filter(agr =>
					horsey(inputValue, quitaAcentos(agr.name.toLowerCase()))
				);
	}

	onChange(event, { newValue }) {
		// otherwise, let the change go through
		this.setState({ value: newValue });
	}

	// Autosuggest will call this function every time you need to update suggestions.
	// You already implemented this logic above, so just use it.
	onSuggestionsFetchRequested({ value }) {
		this.setState({
			suggestions: this.getSuggestions(value)
		});
	}

	// Autosuggest will call this function every time you need to clear suggestions.
	onSuggestionsClearRequested() {
		this.setState({
			suggestions: [],
			ide: ""
		});
	}

	onSuggestionSelected(event, { suggestionValue }) {
		if (this.state.ide) {
			this.props.setIdeSec(this.state.ide);
		} else {
			this.props.setIdeSec(event.target.dataset.ide);
		}
		// return suggestionValue;
	}

	render() {
		const getSuggestionValue = suggestion => {
			this.setState({ ide: suggestion.ide });
			this.props.setIdeSec(this.state.ide);
			return suggestion.name;
		};
		// Use your imagination to render suggestions.
		const renderSuggestion = suggestion => (
			<div data-ide={suggestion.ide}>{suggestion.name}</div>
		);

		const { value, suggestions } = this.state;
		// Autosuggest will pass through all these props to the input.
		const inputProps = {
			placeholder: "Teclea el nombre de la agrupación",
			value,
			onChange: this.onChange
		};
		// Render
		return (
			<div>
				<div className="trama_busqueda">
					<div className="busqueda" style={{ position: "relative" }}>
						<Autosuggest
							suggestions={suggestions}
							onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
							onSuggestionsClearRequested={this.onSuggestionsClearRequested}
							onSuggestionSelected={this.onSuggestionSelected}
							getSuggestionValue={getSuggestionValue}
							renderSuggestion={renderSuggestion}
							inputProps={inputProps}
							theme={theme}
						/>
						<SVGInline
							style={{
								width: "28px",
								height: "28px",
								position: "absolute",
								top: "17px",
								right: "10px",
								zIndex: 100
							}}
							svg={
								"<svg width='14' height='16' viewBox='0 0 14 16' fill='#8D959D'><path d='M8 12.6V0H6v12.7l-4.7-5L0 9l7 7 7-7-1.3-1.3z'></path></svg>"
							}
						/>
						<div />
					</div>
				</div>
			</div>
		);
	}
}

export default Search;



// WEBPACK FOOTER //
// ./src/components/Search.js